import React from 'react';
import { Users, Globe, Star, ArrowRight } from 'lucide-react';

const GearChoiceModal = ({ onSelectCommunity, onSelectPublic, onSelectReviews, onClose }) => {
  return (
    <div
      className="gear-choice-outer"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        overflow: 'auto'
      }}
    >
      <div style={{ 
        maxWidth: '1100px', 
        width: '100%',
        textAlign: 'center'
      }}>
        {/* Subtitle (header already shows the "Gear & Equipment" title, so no duplicate here) */}
        <p style={{
          fontSize: '1rem',
          color: 'rgba(255, 255, 255, 0.6)',
          marginBottom: '2.5rem'
        }}>
          Browse community listings, search public marketplaces, or read expert reviews
        </p>

        {/* Choice Cards - 3 columns */}
        <div className="gear-choice-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '1.5rem'
        }}>
          {/* Community Card */}
          <button
            onClick={onSelectCommunity}
            data-testid="community-listings-card"
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              border: '2px solid rgba(0, 255, 255, 0.3)',
              borderRadius: '20px',
              padding: '2.5rem 2rem',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#00ffff';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 255, 255, 0.3)';
              e.currentTarget.style.background = 'rgba(0, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(0, 255, 255, 0.3)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
            }}
          >
            {/* Gradient overlay */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '150px',
              background: 'linear-gradient(135deg, rgba(0, 255, 255, 0.1), transparent)',
              pointerEvents: 'none'
            }} />

            {/* Icon */}
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #00ffff, #0080ff)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 30px rgba(0, 255, 255, 0.4)'
            }}>
              <Users size={40} color="#fff" />
            </div>

            {/* Title */}
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#fff',
              margin: '0 0 0.75rem 0'
            }}>
              Community Listings
            </h3>

            {/* Description */}
            <p style={{
              fontSize: '0.95rem',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0 0 1.5rem 0',
              lineHeight: '1.5'
            }}>
              Buy & sell directly with BeatSeek members. Support fellow DJs and find local deals.
            </p>

            {/* Features */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              marginBottom: '1.5rem'
            }}>
              {['Direct seller contact', 'Local pickup options', 'Community verified'].map((feature, idx) => (
                <div key={idx} style={{
                  fontSize: '0.85rem',
                  color: '#00ffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}>
                  <span>✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              color: '#00ffff',
              fontWeight: '600',
              fontSize: '1rem'
            }}>
              <span>Browse Community</span>
              <ArrowRight size={18} />
            </div>
          </button>

          {/* Public Marketplace Card */}
          <button
            onClick={onSelectPublic}
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              border: '2px solid rgba(255, 0, 255, 0.3)',
              borderRadius: '20px',
              padding: '2.5rem 2rem',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#ff00ff';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(255, 0, 255, 0.3)';
              e.currentTarget.style.background = 'rgba(255, 0, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(255, 0, 255, 0.3)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
            }}
          >
            {/* Gradient overlay */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '150px',
              background: 'linear-gradient(135deg, rgba(255, 0, 255, 0.1), transparent)',
              pointerEvents: 'none'
            }} />

            {/* Icon */}
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #ff00ff, #ff6b35)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 30px rgba(255, 0, 255, 0.4)'
            }}>
              <Globe size={40} color="#fff" />
            </div>

            {/* Title */}
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#fff',
              margin: '0 0 0.75rem 0'
            }}>
              Public Marketplaces
            </h3>

            {/* Description */}
            <p style={{
              fontSize: '0.95rem',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0 0 1.5rem 0',
              lineHeight: '1.5'
            }}>
              Search Reverb & eBay for DJ gear, synths, and recording equipment from sellers worldwide.
            </p>

            {/* Features */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              marginBottom: '1.5rem'
            }}>
              {['Reverb + eBay listings', 'DJ & Audio Gear', 'Recording Equipment'].map((feature, idx) => (
                <div key={idx} style={{
                  fontSize: '0.85rem',
                  color: '#ff00ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}>
                  <span>✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              color: '#ff00ff',
              fontWeight: '600',
              fontSize: '1rem'
            }}>
              <span>Search Marketplaces</span>
              <ArrowRight size={18} />
            </div>
          </button>

          {/* Gear Reviews Card */}
          <button
            onClick={onSelectReviews}
            data-testid="gear-reviews-card"
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              border: '2px solid rgba(251, 191, 36, 0.3)',
              borderRadius: '20px',
              padding: '2.5rem 2rem',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#fbbf24';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(251, 191, 36, 0.3)';
              e.currentTarget.style.background = 'rgba(251, 191, 36, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(251, 191, 36, 0.3)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
            }}
          >
            {/* Gradient overlay */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '150px',
              background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.1), transparent)',
              pointerEvents: 'none'
            }} />

            {/* Icon */}
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 30px rgba(251, 191, 36, 0.4)'
            }}>
              <Star size={40} color="#fff" fill="#fff" />
            </div>

            {/* Title */}
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#fff',
              margin: '0 0 0.75rem 0'
            }}>
              Gear Reviews
            </h3>

            {/* Description */}
            <p style={{
              fontSize: '0.95rem',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0 0 1.5rem 0',
              lineHeight: '1.5'
            }}>
              Expert reviews on DJ controllers, turntables, headphones, monitors & more.
            </p>

            {/* Features */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              marginBottom: '1.5rem'
            }}>
              {['Star ratings', 'In-depth analysis', 'DJ & Production gear'].map((feature, idx) => (
                <div key={idx} style={{
                  fontSize: '0.85rem',
                  color: '#fbbf24',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}>
                  <span>✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              color: '#fbbf24',
              fontWeight: '600',
              fontSize: '1rem'
            }}>
              <span>Browse Reviews</span>
              <ArrowRight size={18} />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GearChoiceModal;
